import { render, staticRenderFns } from "./StoryFull.vue?vue&type=template&id=04ea59f4"
import script from "./StoryFull.vue?vue&type=script&lang=js"
export * from "./StoryFull.vue?vue&type=script&lang=js"
import style0 from "froala-editor/css/froala_style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/styles/components/story-prose.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports